import styled from 'styled-components'

export const Wrapper = styled.div`
  ${({ theme }) => theme.flexColumnNoWrap}
  margin: 0;
  padding: 30px;
  width: 100%;
`
